module.exports = __webpack_public_path__ + "img/VISA_60x36.8f14355f.jpg";